import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ShapesInterface } from 'src/app/shared/models/shapes.model';
import { StopsInterface } from 'src/app/shared/models/stops.model';

/**
 * MapService
 */
@Injectable()
export class MapService {

  /** Set the stops in the map */
  public mainObservable = new Observable((observer) => {
    observer.next();
    observer.complete();
  });

  /** Set shapes */
  public shapesObservable = new Observable((observer) => {
    observer.next();
    observer.complete();
  });

  /** Set go to ubication selection */
  public ubicationObservable = new Observable((observer) => {
    observer.next();
    observer.complete();
  });

  /** Clear map */
  public clearObservable = new Observable((observer) => {
    observer.next();
    observer.complete();
  });

  private configSubject: Subject<StopsInterface>;

  private shapesSubject: Subject<ShapesInterface>;

  private ubicationSubject: Subject<any[]>;

  private clearSubject: Subject<boolean>;

  /**
   * Creates an instance of map service.
   */
  constructor() {

    /** Stops */
    this.configSubject = new Subject();
    this.mainObservable = this.configSubject.asObservable();

    /** Shapes */
    this.shapesSubject = new Subject();
    this.shapesObservable = this.shapesSubject.asObservable();

    /** Location */
    this.ubicationSubject = new Subject();
    this.ubicationObservable = this.ubicationSubject.asObservable();

    /** Clear */
    this.clearSubject = new Subject();
    this.clearObservable = this.clearSubject.asObservable();

  }

  /**
   * Sets stop points
   *
   * @param stops
   */
  setStopPoints(stops: StopsInterface): void {
    this.configSubject.next(stops);
  }

  /**
   * Sets shapes points
   *
   * @param shapes
   */
  setShapesPoints(shapes: ShapesInterface): void {
    this.shapesSubject.next(shapes);
  }

  /**
   * Sets ubication point
   *
   * @param shapes
   */
  setUbicationPoint(location: any): void {
    this.ubicationSubject.next(location);
  }

  /**
   * Clears map
   */
  clearMap(): void {
    this.clearSubject.next(true);
  }

}
